import React from 'react'
import propTypes from 'prop-types'

import LoadingIndicator from '@/components/LoadingIndicator'
import { ReportTable } from '@/components/report-tables'
import ErrorBoundary from '@/components/ErrorBoundary'

class ReportSubmissionTable extends React.PureComponent {
  static propTypes = {
    sourceData: propTypes.array,
    isLoading: propTypes.bool,
    reportSubmission: propTypes.object,
    sourceHeaders: propTypes.object,
    sourceRowHeaders: propTypes.object,
    isRtl: propTypes.bool,
    cellMetadata: propTypes.array
  }

  render () {
    if (this.props.isLoading) { return <LoadingIndicator /> }
    if (this.props.reportSubmission && this.props.reportSubmission) {
      return <React.Fragment>
        <ErrorBoundary>
          <ReportTable
            persistenceId={this.props.reportSubmission.code}
            isRtl={this.props.isRtl}
            sourceHeaders={this.props.sourceHeaders}
            sourceRowHeaders={this.props.sourceRowHeaders}
            sourceData={this.props.sourceData}
            defaultMetadata={{ readOnly: true }}
            isInternal
            cellMetadata={this.props.cellMetadata}
            renderAllRows
            commentMode='editable'
            readOnly />
        </ErrorBoundary>
      </React.Fragment>
    }
    return null
  }
}

export { ReportSubmissionTable }



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportSubmissionGroups/submissions/detail/reportSubmissionTable.js